import { useState } from "react";

type TimeInForce = "GTC" | "IOC" | "ALO";

type TimeInForceSelectorProps = {
  value: TimeInForce;
  onChange: (value: TimeInForce) => void;
  orderType: "market" | "limit" | "advanced";
};

const TIF_OPTIONS = {
  GTC: {
    label: "GTC",
    fullName: "Good Till Canceled",
    description: "Your order stays active until it's filled or you cancel it.",
  },
  IOC: {
    label: "IOC",
    fullName: "Immediate Or Cancel",
    description: "Fills what it can right away, cancels the rest.",
  },
  ALO: {
    label: "ALO",
    fullName: "Add Liquidity Only (Post-Only)",
    description: "Places your order on the book. Won't execute immediately, only when price is hit.",
  },
};

export const TimeInForceSelector = ({
  value,
  onChange,
  orderType,
}: TimeInForceSelectorProps) => {
  const [isOpen, setIsOpen] = useState(false);

  // Only show for limit orders
  if (orderType !== "limit") {
    return null;
  }

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className="px-2 py-0.5 bg-muted/50 rounded font-medium hover:bg-muted transition-colors text-xs cursor-pointer"
      >
        {value}
      </button>

      {isOpen && (
        <>
          {/* Backdrop to close menu */}
          <div
            className="fixed inset-0 z-10"
            onClick={() => setIsOpen(false)}
          />
          
          {/* Dropdown menu */}
          <div className="absolute top-full right-0 mt-1 bg-background border border-border rounded shadow-lg py-1 min-w-[280px] z-20">
            {(Object.keys(TIF_OPTIONS) as TimeInForce[]).map((tif) => (
              <button
                key={tif}
                type="button"
                onClick={() => {
                  if (tif !== "IOC") {
                    onChange(tif);
                    setIsOpen(false);
                  }
                }}
                disabled={tif === "IOC"}
                className={`w-full px-3 py-2.5 text-left hover:bg-muted transition-colors relative ${
                  value === tif ? "bg-muted/50" : ""
                } ${tif === "IOC" ? "opacity-50 cursor-not-allowed" : ""}`}
                title={tif === "IOC" ? "Coming Soon" : ""}
              >
                <div className="flex flex-col gap-0.5">
                  <div className="text-sm font-medium flex items-center gap-2">
                    {TIF_OPTIONS[tif].label}
                    {tif === "IOC" && (
                      <span className="text-[10px] text-muted-foreground">(Coming Soon)</span>
                    )}
                  </div>
                  <div className="text-xs text-muted-foreground">
                    {TIF_OPTIONS[tif].fullName}: {TIF_OPTIONS[tif].description}
                  </div>
                </div>
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
};

